export enum WidgetTypes {
    INPUT_WIDGET = 'inputWidget',
    SKILLS_WIDGET = 'skillsWidget',
    FEEDBACK_WIDGET = 'feedbackWidget',
}
